

<template>
  <v-container>

     <div style="border-style: solid; border-color: #2196F3">


           <div v-if="layer_index > -1">

             <v-row>

            <v-col cols="12"  xs="12" sm="12" md="12">


                                <v-row class="info_row" >
                                   
                                  <div>
         <v-list-item-title style="font-size: 24px" class="text-wrap">
                                      {{selectedLayer.text}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>(באלפים)</v-list-item-subtitle>
                                    <div v-if="selected_data.length > 0">
                                        <v-list-item-subtitle style="font-weight: bold;" v-if="selected_data"> {{selected_data[0]}} / {{selected_data[1]}}</v-list-item-subtitle>
                                    </div>

                                    
                                <v-row v-if="selected_data.length > 0" class="center info_row">
                                    <v-chip
                                        class="ma-2"
                                        color="navy"
                                        >
                                        סה"כ באוכלוסיה: {{Math.floor(selected_data[5]*1000).toLocaleString()}}
                                    </v-chip>

      
                                </v-row>
                                  </div>

                                        <v-spacer></v-spacer>

                     
                                
                               <v-btn  @click="dialog = true"
                                class="mx-2"
                                fab
                                dark
                                small
                                color="primary"
                              >
                                <v-icon dark>
                                  mdi-help
                                </v-icon>
                              </v-btn>

                                

                                    
                           
                                </v-row>

                               


                                <v-row class="center info_row">
                                     <v-spacer></v-spacer> <doughnut-chart v-if="selected_data.length > 0" style="max-width:300px; max-height:250px" :cData="[selected_data[2],selected_data[3], selected_data[4]]"></doughnut-chart><v-spacer></v-spacer>
                                </v-row>

                </v-col>

 
                </v-row>

              </div>
     </div>


     <v-dialog
      v-model="dialog"
      width="300"
    >
      <v-system-bar
      dark
      color="primary"
    >
      <v-spacer></v-spacer>
      <v-icon @click="dialog = false">mdi-close</v-icon>
    </v-system-bar>

                    <v-spacer></v-spacer>
                      <v-card center >
                    <v-img
                      :src="img" max-height="430" max-width="300"
                    >
                    
                    </v-img>
                    </v-card>
                    <v-spacer></v-spacer>
                              

    </v-dialog>


  </v-container>
</template>



<script>



import DoughnutChart from '@/components/DoughnutChart'
export default {


    name: 'ArabDataDiv',

    components: {
        DoughnutChart
    },
    data: () => ({
      dialog: false


        

    }),
    computed:{
      layer_index(){
        return this.$store.state.layer_index;
      },
      selectedLayer(){
        return this.$store.state.selectedLayer;
      },
      selected_data(){
        return this.$store.state.selected_data_arab;
      },
      img(){
        return this.$store.state.img;
      },
    },

    



    //props: ['layer_index', 'selectedLayer', 'selected_data'],


  }

</script>

<style scoped>
.info_row{
  background: #FFFFFF 0% 0% no-repeat padding-box;
                        box-shadow: 0px 2px 7px #00000014;
                        opacity: 1; margin: 5px;
}
</style>
